'use client';

import { tw } from '@repo/ui';

import { ClaimSuccess } from '@claim/components/success/claim-success';

import { useClaim } from '../../../../hooks/use-claim';
import { InProgress } from './in-progress';

export const Claiming: React.FC = () => {
  const { success } = useClaim();

  return (
    <div
      className={tw(
        'relative flex flex-col items-center gap-7 text-white',
        success ? 'min-h-[560px] justify-end' : 'min-h-[540px] justify-between',
      )}
    >
      {success ? <ClaimSuccess /> : <InProgress />}
    </div>
  );
};
